module.exports = __webpack_public_path__ + "img/轮播2.37c0055d.jpg";